<div class="modal-header">
    <h4 class="modal-title">Notificaciones</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <ng-container [formGroup]="filterNotif">
        <div class="row">
            <div class="form-group col-md-12">
                <!-- <label class="col-form-label">Estado</label> -->
                <select class="form-control" formControlName="estado">
                  <option value='T' selected>Todas las notificaciones</option>
                  <option value='N' selected>Notificaciones no leídas</option>
                  <option value='L' selected>Notificaciones leídas</option>
                </select>
            </div>
        </div>
    </ng-container> 

    <ngb-alert *ngIf="(Notificaciones !== undefined) && (Notificaciones.length == 0)" [type]="'primary'" [dismissible]="false">No se encuentran notificaciones para mostrar.</ngb-alert>

    <ng-container *ngFor="let notif of Notificaciones">
        <div class="card o-hidden" style="margin-bottom: 7px" (click)="LeerNotif(notif)">
            <div [ngClass]="notif.Estado === 'N' ? 'bg-danger card-body' : 'bg-success card-body'" >
            <div class="media static-top-widget">
                <div class="align-self-center text-center">
                <app-feather-icons [icon]="notif.Estado === 'N' ? 'bell' : 'check'"></app-feather-icons>
                </div>
                <div class="media-body">
                    <span class="m-0">
                        ({{ notif.FechaNotificado || notif.FechaNotificacion }})
                        {{ notif.Observacion.Titulo || notif.Observacion.titulo || 'Titulo no disponible' }}
                    </span>
                    <h5 class="mb-0">{{ notif.Observacion.Mensaje || notif.Observacion.mensaje || 'Mensaje no disponible' }}</h5>
                    <i *ngIf="notif.Estado === 'N'" class="icon-bg" data-feather="bell"></i>
                    <i *ngIf="notif.Estado === 'L'" class="icon-bg" data-feather="check"></i>
                </div>
            </div>
            </div>
        </div>
    </ng-container>
    <p-table *ngIf="totalElements !== 0" [paginator]="true" [rows]="pageSize" [totalRecords]="totalElements" [lazy]="true" (onLazyLoad)="setPage($event)"  [showCurrentPageReport]="false" currentPageReportTemplate="{{'Showing' | translate }} {first} {{'to' | translate }} {last} {{'of' | translate }} {totalRecords} {{'entries'| translate }}">
    </p-table>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-success" (click)="marcarTodoLeidos()">Marcar todos como leidos</button>
    <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Cerrar</button>
</div>
